import { defineMessages } from "react-intl";
import { translate } from "./translate";

const intlMessages = defineMessages({
  required: {
    id: "validations.required",
    defaultMessage: "doit être rempli(e)"
  },
  length_too_short: {
    id: "validations.length_too_short",
    defaultMessage: "est trop court(e)"
  },
  length_too_long: {
    id: "validations.length_too_long",
    defaultMessage: "est trop long(ue)"
  },
  string_length_too_short: {
    id: "validations.string_length_too_short",
    defaultMessage: `
      doit faire au moins {count, plural, one {# caractère} other {# caractères}}
    `
  },
  string_length_too_long: {
    id: "validations.string_length_too_long",
    defaultMessage: `
      doit faire au maximum {count, plural, one {# caractère} other {# caractères}}
    `
  },
  other_value_required: {
    id: "validations.other_value_required",
    defaultMessage: `
      le champ texte "Autre" doit être rempli
    `
  },
  must_correspond: {
    id: "validations.must_correspond",
    defaultMessage: "ne correspond pas"
  },
  not_enough_budget_spent: {
    id: "validations.not_enough_budget_spent",
    defaultMessage: "pas assez d'étoiles sélectionnées"
  },
  a_budget_line_must_be_selected: {
    id: "validations.a_budget_line_must_be_selected",
    defaultMessage: "au moins une ligne budgétaire doit être sélectionnée"
  },
  invalid_email_format: {
    id: "validations.invalid_email_format",
    defaultMessage: "n'est pas une adresse e-mail valide"
  },
  not_enough_options_selected_per_item: {
    id: "validations.not_enough_options_selected_per_item",
    defaultMessage: `
      doit avoir au moins {count, plural,
        one { une option sélectionnée }
        other { {count} options sélectionnées }
      } par ligne
    `
  },
  too_many_options_selected_per_item: {
    id: "validations.too_many_options_selected_per_item",
    defaultMessage: `
      doit avoir au maximum {count, plural,
        one { une option sélectionnée }
        other { {count} options sélectionnées }
      } par ligne
    `
  },
  uploads_incomplete: {
    id: "validations.uploads_incomplete",
    defaultMessage: `
      des fichiers n'ont pas terminé leur envoi, merci de patienter qu'ils soient tous 
      envoyés.
    `
  },
  budget_goal_not_reached: {
    id: "validations.budget_goal_not_reached",
    defaultMessage: `
      l'objectif budgétaire de {goal, number} {unit} n'a pas été atteint
    `
  }
});

export const errorMessages = {
  required: translate(intlMessages.required),
  lengthTooShort: translate(intlMessages.length_too_short),
  lengthTooLong: translate(intlMessages.length_too_long),
  stringLengthTooShort: count =>
    translate(intlMessages.string_length_too_short, { count }),
  stringLengthTooLong: count => translate(intlMessages.string_length_too_long, { count }),
  otherValueRequired: translate(intlMessages.other_value_required),
  mustCorrespond: translate(intlMessages.must_correspond),
  notEnoughBudgetSpent: translate(intlMessages.not_enough_budget_spent),
  budgetMustBeFilled: translate(intlMessages.a_budget_line_must_be_selected),
  invalidEmailFormat: translate(intlMessages.invalid_email_format),
  notEnoughOptionsSelectedPerItem: minimum =>
    translate(intlMessages.not_enough_options_selected_per_item, { count: minimum }),
  tooManyOptionsSelectedPerItem: maximum =>
    translate(intlMessages.too_many_options_selected_per_item, { count: maximum }),
  uploadsIncomplete: translate(intlMessages.uploads_incomplete),
  budgetGoalNotReached: (goal, unit) =>
    translate(intlMessages.budget_goal_not_reached, { goal, unit })
};
